import { render, staticRenderFns } from "./SyncObtain.vue?vue&type=template&id=60f1dc27&scoped=true"
import script from "./SyncObtain.vue?vue&type=script&lang=js"
export * from "./SyncObtain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1dc27",
  null
  
)

export default component.exports